module.exports = __webpack_public_path__ + "media/assets/img/bg-pricing-b1a6668763157fceb5b2cccaf9f22677.jpeg";